import React from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Modal, TextField, Typography } from '@mui/material';

import styled from '@emotion/styled';
import { Form, FormikProvider, useFormik } from 'formik';
import { useTranslate } from 'react-redux-multilingual';
import * as Yup from 'yup';
import './AuthModal.css';
// import { useSnackbar } from 'notistack';
import { connect, useDispatch } from 'react-redux';

import { LetsGoBtn } from '../../components/Buttons';
import { StyledLabel } from '../../components/StyledComponents';
import { setIsOpenTTNModal } from '../../redux/mainReducer';
// import {  encode as btoa, decode as atob } from 'base-64';
// import sha256 from 'crypto-js/sha256';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 550 },
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', sm: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  display: 'flex',
  justifyContent: 'center'
};

// const StyledButton = styled(LoadingButton)(({ theme }) => ({
//   color: theme.palette.common.white,
//   fontFamily: 'Noto Sans',
//   textTransform: 'uppercase',
//   borderRadius: '50px',
//   maxWidth: 'fit-content',
//   minWidth: '150px',
//   padding: '0 20px',
//   '&:hover': { backgroundColor: 'transparent' },
//   boxShadow: '0px 7px 10px 1px rgb(145 158 171 / 30%)',
//   background:
//     'linear-gradient(353.54deg, #043B1F 3.03%, #0D7834 37.41%, #0E8D3D 67.77%, #0B9552 104.82%)'
// }));

const CssTextField2FA = styled(TextField)({
  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    border: '2px solid #60A5DF'
  },
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#A1A1A1',
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInput-root.Mui-focused:after': {
    borderBottom: '2px #000000 solid'
  },
  '& .MuiInput-root:hover:not(.Mui-disabled):before': {
    borderBottom: '2px #000000 solid'
  },
  '& .MuiInput-root:not(.Mui-error):before': {
    borderBottom: '2px #000000 solid'
  },
  margin: '5px auto'
});

function TTNModal({ isOpenModal, func }) {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (window.screen.width <= 600) {
  //     setScreenType('mobile');
  //   }
  // }, []);
  const translate = useTranslate();
  // const { enqueueSnackbar } = useSnackbar();

  const schema = Yup.object().shape({
    TTN: Yup.string()
      .required(translate('error_required'))
      .min(14, 'Номер ТТН має складатись з 14 символів')
  });

  const formik = useFormik({
    initialValues: {
      TTN: ''
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: (values, { resetForm, setErrors }) => {
      func(values.TTN);
    }
  });

  const {
    errors,
    touched,
    setFieldValue,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    resetForm
  } = formik;

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          dispatch(setIsOpenTTNModal({ isOpen: false, func: null }));
          resetForm();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_auth_modal"
      >
        <Box sx={style} className="bonfair_auth_modal-box">
          <CloseIcon
            className="bonfair_auth_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenTTNModal({ isOpen: false, func: null }));
              resetForm();
            }}
          />

          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
              style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
            >
              <Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <StyledLabel className="enable2FAModal-title-text">{`Додайте номер ТТН`}</StyledLabel>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', flexDirection: 'column' }}
                  className="authModal-inputs-first"
                >
                  <Typography
                    className="authModal-main-text"
                    style={{
                      marginBottom: '30px',
                      textAlign: 'center',
                      fontSize: '16px',
                      fontweight: '500',
                      fontFamily: 'FixelText-Medium',
                      color: '#7c7c7c'
                    }}
                  >
                    {`Щоб змінити статус замовлення на “відправлено” додайте будь ласка номер накладної з пошти`}
                  </Typography>

                  <CssTextField2FA
                    {...getFieldProps('TTN')}
                    placeholder="XX-XXXX-XXXX-XXXX"
                    size="normal"
                    value={values.TTN}
                    fullWidth
                    inputProps={{ style: { textAlign: 'left' } }}
                    error={Boolean(touched.TTN && errors.TTN)}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z0-9]*$/.test(value) && value.length !== 15) {
                        setFieldValue('TTN', value);
                      }
                    }}
                  >
                    {values.TTN}
                  </CssTextField2FA>

                  {touched.TTN && errors.TTN && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular',
                        textAlign: 'center'
                      }}
                    >
                      {errors.TTN}
                    </div>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                >
                  <LetsGoBtn
                    id="loginBtn2FA"
                    colorScheme="blue"
                    disabled={values.TTN.length === 0}
                    size="large"
                    onClick={() => {
                      submitForm();
                    }}
                    width={'100%'}
                    style={{ textTransform: 'inherit' }}
                    text={'Додати'}
                  />
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(TTNModal);
